//all of this will be run with the "i" flag (case insensitive)
//inside of log worker
export const StringObfuscationRegexes = [
  //email
  /([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*/,
  //phone number
  /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/,
  //ipv4
  /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/,

  //untested:
  //Personnummer
  // /\b\d{6}[-+]\d{4}\b/,
  // //telefonnummer
  // /\b(?:\+46|0)[\s\-]?\d{1,3}[\s\-]?\d{2,3}[\s\-]?\d{2,3}[\s\-]?\d{2,3}\b/,
  // //postnummer
  // /\b\d{3}\s?\d{2}\b/,
  // //kreditkortsnummer
  // /\b(?:\d[ -]*?){13,16}\b/,
  // //bankkontonummer
  // /\b\d{4}[\s\-]?\d{4}[\s\-]?\d{4}[\s\-]?\d{4}\b/,
  // //swishnummer
  // /\b123[\s\-]?\d{3}[\s\-]?\d{3}\b/,
  // //mac-adress
  // /\b(?:[0-9A-Fa-f]{2}[:\-]){5}[0-9A-Fa-f]{2}\b/,
  // //ip-adress (IPv6)
  // /\b(?:[A-Fa-f0-9]{1,4}:){7}[A-Fa-f0-9]{1,4}\b/,
  // //organisationsnummer
  // /\b\d{6}[-]?\d{4}\b/,
  // //passnummer
  // /\b[A-Z]{2}\d{6}\b/,
  // //körkortsnummer
  // /\b[A-Z]{1,2}\d{6}\b/,
  // //försäkringsnummer
  // /\b\d{10}\b/,
  // //bankgironummer
  // /\b\d{3,4}[-]?\d{4}\b/,
  // //plusgironummer
  // /\b\d{2,5}[-]?\d{1,5}\b/,
  // //kontokortsnummer
  // /\b(?:\d{4}[\s\-]?){3}\d{4}\b/,
  // //Employee ID
  // /\bEMP\d{4,10}\b/,
  // //Passport Number
  // /\b[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]\b/,
  // //National Identification Number
  // /\b\d{3}-\d{2}-\d{4}\b/,
  // //Bank Account Number
  // /\b\d{9,18}\b/,
  // //Credit Card Information
  // /\b(?:\d[ -]*?){13,16}\b/,
  // //Home Address
  // /\d{1,5}\s\w+(\s\w+)*,\s\w+,\s\w{2}\s\d{5}/,
  // //Phone Number
  // /\b(?:\+?1\s*(?:[.-]\s*)?)?(?:\(?\d{3}\)?|\d{3})(?:[.-]\s*)?\d{3}(?:[.-]\s*)?\d{4}\b/,
  // //Personal Website URL (https)
  // /https?:\/\/(www\.)?[a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b/,
  // //Personal Website URL (http)
  // /http?:\/\/(www\.)?[a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b/,
  // //Browser History
  // /\bhttps?:\/\/[^\s]+\b/,
  // //Browser History (http)
  // /\bhttp?:\/\/[^\s]+\b/,
  // //GPS Coordinates
  // /\b\d{1,2}\.\d+,\s?-?\d{1,3}\.\d+\b/,
  // //MAC Address
  // /\b([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})\b/,
  // //Device IMEI Number
  // /\b\d{15}\b/,
  // //Flight Booking Records
  // /\bflight\s?(number|code)?[:\-]?\s?[A-Z]{2}\d{3,4}\b/,
  // //Height and Weight
  // /\b\d{2,3}\s?(cm|kg|lbs|in)\b/,
];
